import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card__head d-flex aling-items-center justify-content-between" }
const _hoisted_2 = { class: "d-flex aling-items-center ml-2" }
const _hoisted_3 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "my-0" }
const _hoisted_7 = {
  key: 0,
  class: "my-0"
}
const _hoisted_8 = {
  key: 1,
  class: "my-0"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "my-0" }
const _hoisted_11 = {
  key: 0,
  class: "my-0 text-gray"
}
const _hoisted_12 = {
  key: 1,
  class: "my-0 text-gray"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, _mergeProps(_ctx.$attrs, {
      class: ["card--slim", { 'm-1': _ctx.small }]
    }), {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InlineSvgScoped, {
                src: require(`@/assets/images/entrancePlants/icon-badge.svg`)
                            ,
                "aria-label": "icon-badge"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_4, [
              (!_ctx.small)
                ? (_openBlock(), _createBlock("span", _hoisted_5, [
                    _createVNode("h4", _hoisted_6, _toDisplayString(_ctx.badge.badgeCode), 1),
                    (_ctx.badge.apartment)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.badge.apartment.name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.badge.gateGuest)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(`${_ctx.badge.gateGuest.surname} ${_ctx.badge.gateGuest.name}`), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.small)
                ? (_openBlock(), _createBlock("span", _hoisted_9, [
                    _createVNode("h6", _hoisted_10, _toDisplayString(_ctx.badge.badgeCode), 1),
                    (_ctx.badge.apartment)
                      ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.badge.apartment.name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.badge.gateGuest)
                      ? (_openBlock(), _createBlock("small", _hoisted_12, _toDisplayString(`${_ctx.badge.gateGuest.surname} ${_ctx.badge.gateGuest.name}`), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.small && !_ctx.badgeTab)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                disabled: _ctx.disabled,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDeleteBadgeConfirm && _ctx.toggleDeleteBadgeConfirm(...args))),
                class: "btn-stripped text-danger"
              }, _toDisplayString(_ctx.$t("AppResource.Delete")), 9, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.small || _ctx.badgeTab)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                disabled: _ctx.disabled,
                class: "text-danger ml-auto p-button-text",
                onClick: _ctx.handleDeleteBadge
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 16, ["class"]),
    (!_ctx.small)
      ? (_openBlock(), _createBlock(_component_DialogConfirmDelete, {
          key: 0,
          "is-visible": _ctx.isVisibleDeleteBadgeConfirm,
          title: _ctx.$t('AppResourceEP.BadgeRemotionTitle'),
          message: _ctx.$t('AppResourceEP.BadgeRemotionMessage'),
          onHideDialog: _ctx.toggleDeleteBadgeConfirm,
          onConfirm: _ctx.handleDeleteBadge
        }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}